export default __webpack_public_path__ + "static/media/banner-committees-new.db0646c7.webp";